import { FC } from 'react';
import { Breadcrumb, Button, Col, Row, Space } from 'antd';
import { TbChevronRight, TbDotsVertical, TbLayout, TbReportAnalytics } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useReportComponentAccess } from '@/hooks/useNestedResourceAccess';
import {
    ReportComponentActionsDropdown,
    ReportComponentCommentButton,
    ReportComponentIcon,
    ReportComponentLockButton,
} from '@/shared/components';
import { useDashboardStore, useReportStore } from '@/stores';
import { ReportComponent } from '@/types';

interface HeaderProps {
    component: ReportComponent;
}

const Header: FC<HeaderProps> = ({ component }): JSX.Element => {
    const { token } = useAntDesignTheme();
    const reportAccess = useReportComponentAccess(component);

    const { selectedDashboard } = useDashboardStore();
    const { selectedReport } = useReportStore();

    return (
        <Row
            style={{
                padding: '1.25rem 1rem',
                borderBottom: `1px solid ${token.colorBorder}`,
                backgroundColor: token.colorBgContainer,
            }}
            wrap={false}
            align={'middle'}
        >
            {/* <Col flex='none'>
                <PreviousNextResourceButtonGroup
                    resource={undefined}
                    resources={undefined}
                    singularResourceLabel={'reportcomponent'}
                    pluralResourceLabel={'reportcomponents'}
                />
            </Col> */}
            {/* <Col flex='none'>
                <Divider type='vertical' />
            </Col> */}
            <Col flex='none'>
                <Breadcrumb separator={<TbChevronRight style={{ verticalAlign: '-0.15rem' }} />}>
                    <Breadcrumb.Item>
                        <TbLayout style={{ verticalAlign: '-0.125rem', marginRight: '0.25rem' }} />
                        {selectedDashboard?.name}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <TbReportAnalytics style={{ verticalAlign: '-0.125rem', marginRight: '0.25rem' }} />
                        {selectedReport?.name}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <ReportComponentIcon size={16} type={component.type} style={{ marginRight: '0.25rem' }} />
                        {component?.name}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </Col>
            <Col flex='auto' />
            {component.locked && (
                <Col flex='none' style={{ marginRight: '0.5rem' }}>
                    <ReportComponentLockButton component={component} />
                </Col>
            )}
            {/* <Col flex='none'>
                <Divider type='vertical' />
            </Col> */}
            {/* <Col flex='none'>
                <Button size='small' style={{ padding: '0.25rem' }}>
                    <TbSparkles style={{ color: token.purple6 }} />
                </Button>
            </Col> */}
            {/* <Col flex='none'>
                <Divider type='vertical' />
            </Col> */}
            <Col flex='none'>
                <Space.Compact>
                    {reportAccess.canComment && (
                        <ReportComponentCommentButton component={component} tooltipPlacement='topRight' />
                    )}
                    <ReportComponentActionsDropdown component={component}>
                        <Button size='small'>
                            <TbDotsVertical style={{ color: token.colorTextTertiary }} />
                        </Button>
                    </ReportComponentActionsDropdown>
                </Space.Compact>
            </Col>
        </Row>
    );
};

export default Header;
